import SubformListComponent from "./subform-list.component";
import ComponentsCollection from '../../../general/js/components-collection';
import BuyerFormComponent from "./buyer-form.component";

export default class BuyersSubformListComponent extends SubformListComponent {

    constructor() {
        super(...arguments);
        this.buyersForms = {};
    }

    setRegisterByTelephone(value) {
        this.registerByTelephone = value;
        Object.keys(this.buyersForms).forEach(id => {
            this.buyersForms[id].setRegisterByTelephone(value);
        })
    }

    setBuyingFor(value) {
        this.buyingFor = value;
        Object.keys(this.buyersForms).forEach(id => {
            this.buyersForms[id].setBuyingFor(value);
        })
    }

    onSubformConnected({element, id}) {
        let buyerForm = ComponentsCollection.getInstance().createComponent(element, 'buyer-form', BuyerFormComponent);
        if (buyerForm) {
            buyerForm.setBuyingFor(this.buyingFor);
            buyerForm.setRegisterByTelephone(this.registerByTelephone);
            this.buyersForms[id] = buyerForm;
        }
    }

    onSubformDisconnected({id}) {
        if (id in this.buyersForms) {
            ComponentsCollection.getInstance().destroy(this.buyersForms[id].element);
            delete this.buyersForms[id];
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/register-to-bid/js/buyers-subform-list.component.js